import { putWithAuth, getWithAuth, postWithAuth, patchWithAuth } from '@/util';

export const getSubscriptions = async () => {
  const result = await getWithAuth('/web/payment/users/me/subscriptions');
  return result;
};

export const unsubscribe = async (serialId, platform) => {
  const result = await patchWithAuth(`/web/payment/users/me/subscriptions/${serialId}`, {
    action: 'cancel',
    platform,
  });
  return result;
};
